import { AccordionDetails, styled } from "@mui/material";

const AccessAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  border: "none",
  paddingLeft: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(0),
}));

export default AccessAccordionDetails;
